import { Component } from 'react';
import PropTypes from 'prop-types';
import h from 'react-hyperscript';
import { Link } from 'react-router-dom';
import Typed from 'typed.js';

import './NotFound.css';

class NotFound extends Component {
  componentDidMount() {
    /* istanbul ignore next */
    this.typed = new Typed('.not-found-label', {
      strings: [
        'Resource not found.',
        'Resource not-not lost.',
        'Resource not here.',
        'Resource never to be heard from again',
        'Resource needs watering.',
      ],
      typeSpeed: 100,
      backspeed: 75,
      backDelay: 2000,
      loop: true,
      smartBackspace: true,
    });
  }

  componentWillUnmount() {
    /* istanbul ignore next */
    this.typed.destroy();
  }

  render() {
    const { location: { pathname = [] } = {} } = this.props;

    return h('header.header#header', [
      h('.container', {}, [
        h('figure.logo', [
          h(Link, { to: '/' }, [h('img', { src: 'img/logo-scllc-dark.png', alt: 'Simple City Logo' })]),
        ]),
        h('b', '404: '),
        h('span.not-found-label', ''),
        h('p.animated.shake.delay-50s', {}, [h('br'), h('i', pathname)]),
      ]),
    ]);
  }
}

NotFound.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
};

NotFound.defaultProps = {
  location: {
    pathname: '',
  },
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js